import { isFulfilled } from "@reduxjs/toolkit";
import { t } from "ttag";

import { useToast } from "metabase/common/hooks";
import { useDispatch } from "metabase/lib/redux";
import { getMetabotManagedProviderLimitToastProps } from "metabase/metabot/components/MetabotManagedProviderLimit";
import { METABOT_ERR_MSG } from "metabase/metabot/constants";
import {
  useMetabotAgent,
  useMetabotEnabledEmbeddingAware,
} from "metabase/metabot/hooks";
import { setIsNativeEditorOpen } from "metabase/query_builder/actions";
import { Button } from "metabase/ui";

import { trackQueryFixClicked } from "../../analytics";

export function FixSqlQueryButton() {
  const dispatch = useDispatch();
  const isMetabotEnabled = useMetabotEnabledEmbeddingAware();
  const [sendToast] = useToast();
  const { submitInput, isDoingScience } = useMetabotAgent("sql");

  if (!isMetabotEnabled) {
    return null;
  }

  const handleClick = async () => {
    trackQueryFixClicked();
    await dispatch(setIsNativeEditorOpen(true));
    // SQL and error message are included in the context.
    const action = await submitInput("Fix this SQL query", {
      preventOpenSidebar: true,
    });

    if (!isFulfilled(action) || action.payload.success) {
      return;
    }

    if (action.payload.errorMessage?.type === "locked") {
      sendToast(getMetabotManagedProviderLimitToastProps());
      return;
    }

    sendToast({
      icon: "warning",
      toastColor: "error",
      message: action.payload.errorMessage?.message ?? METABOT_ERR_MSG.default,
    });
  };

  return (
    <Button
      loading={isDoingScience}
      onClick={handleClick}
    >{t`Have Metabot fix it`}</Button>
  );
}
